import React from 'react';
import axios from "../../../../containers/api";
import {showCatchError} from "../../../../helpers/Utils";
import {Button, Card, CardBody, ModalBody, Modal, ModalHeader, Row, ModalFooter, Badge} from "reactstrap";
import {Table} from "../../../../components/table/Table";
import {Colxx, Separator} from "../../../../components/common/CustomBootstrap";
import AddLoadHallShowTime from "./components/AddLoadHallShowTime";
import EditLoadHallShowTime from "./components/EditLoadHallShowTime";

class LoadHallShowTime extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            EditModal: false,
            AddModal: false,
            LoadHallShowTimes: [],
            errors: [],
            ShowTimeSearchTypes: [
                { value: '00:00', text: '00:00' }, 
                { value: '00:30', text: '00:30' }, 
                { value: '01:00', text: '01:00' }, 
                { value: '01:30', text: '01:30' }, 
                { value: '02:00', text: '02:00' }, 
                { value: '02:30', text: '02:30' }, 
                { value: '03:00', text: '03:00' }, 
                { value: '03:30', text: '03:30' }, 
                { value: '04:00', text: '04:00' }, 
                { value: '04:30', text: '04:30' }, 
                { value: '05:00', text: '05:00' }, 
                { value: '05:30', text: '05:30' }, 
                { value: '06:00', text: '06:00' }, 
                { value: '06:30', text: '06:30' }, 
                { value: '07:00', text: '07:00' }, 
                { value: '07:30', text: '07:30' }, 
                { value: '08:00', text: '08:00' }, 
                { value: '08:30', text: '08:30' }, 
                { value: '09:00', text: '09:00' }, 
                { value: '09:30', text: '09:30' }, 
                { value: '10:00', text: '10:00' }, 
                { value: '10:30', text: '10:30' }, 
                { value: '11:00', text: '11:00' }, 
                { value: '11:30', text: '11:30' }, 
                { value: '12:00', text: '12:00' }, 
                { value: '12:30', text: '12:30' }, 
                { value: '13:00', text: '13:00' }, 
                { value: '13:30', text: '13:30' }, 
                { value: '14:00', text: '14:00' }, 
                { value: '14:30', text: '14:30' }, 
                { value: '15:00', text: '15:00' }, 
                { value: '15:30', text: '15:30' }, 
                { value: '16:00', text: '16:00' }, 
                { value: '16:30', text: '16:30' }, 
                { value: '17:00', text: '17:00' }, 
                { value: '17:30', text: '17:30' }, 
                { value: '18:00', text: '18:00' }, 
                { value: '18:30', text: '18:30' }, 
                { value: '19:00', text: '19:00' }, 
                { value: '19:30', text: '19:30' }, 
                { value: '20:00', text: '20:00' }, 
                { value: '20:30', text: '20:30' }, 
                { value: '21:00', text: '21:00' }, 
                { value: '21:30', text: '21:30' }, 
                { value: '22:00', text: '22:00' }, 
                { value: '22:30', text: '22:30' }, 
                { value: '23:00', text: '23:00' },
                
            ],
          
            selectedShowTime: {}
        };
    }

    componentDidMount() {
        this.GetGetByLoadHallId();
    }

    GetGetByLoadHallId = () => {
        this.props.showSpinner();
        axios.get('/api/v1/load-hall-showtimes')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data.length != null && res.data.data.length > 0) {
                    this.setState({ LoadHallShowTimes: res.data.data});
                } else {
                    this.setState({LoadHallShowTimes: []});
                }
                console.log(res.data.data)
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response)
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    closeModal = (modalName) => {
        this.GetGetByLoadHallId();
        this.setState({ [modalName]: false });
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>تنظیمات مشاهده بار</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <div className="d-flex justify-content-center w-100">
                                    <Button outline color="primary" className="mx-3"
                                            onClick={() => this.setState({AddModal: true})}>
                                        افزودن ساعت مشاهده بار
                                    </Button>
                                </div>

                                <Table
                                    tableHeaders={[
                                       
                                        "ساعت", 
                                        "وضعیت", 
                                        "ویرایش",
                                    ]}

                                    tableRow={this.state.LoadHallShowTimes}

                                    tableData={[
                                       
                                        x => {
                                            return x.showTime
                                        },
                                        
                                        x => {
                                            return x.isActive === false ?
                                                <Badge color="outline-danger" className="text-center" pill>غیر فعال</Badge>
                                                :
                                                <Badge color="outline-success" className="text-center" pill>فعال</Badge>
                                        },
                                         
                                        x => {
                                            return (
                                                <Button outline color="info" size="sm"
                                                        onClick={() => this.setState({selectedShowTime: x, EditModal: true})}>
                                                    ویرایش
                                                </Button>
                                            )
                                        }
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>


                <Modal isOpen={this.state.AddModal} size="xlg" toggle={() => this.setState({AddModal: false})}>
                    <ModalHeader toggle={() => this.setState({AddModal: false})}>
                        ساعت مشاهده بار
                    </ModalHeader>
                    <ModalBody>
                        <AddLoadHallShowTime
                            ShowTimeSearchTypes={this.state.ShowTimeSearchTypes}
                           
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({AddModal: false})}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.EditModal} size="xlg" toggle={() => this.setState({EditModal: false})}>
                    <ModalHeader toggle={() => this.setState({EditModal: false})}>
                        ویرایش ساعت مشاهده بار
                    </ModalHeader>
                    <ModalBody>
                        <EditLoadHallShowTime
                            showTime={this.state.selectedShowTime}
                            ShowTimeSearchTypes={this.state.ShowTimeSearchTypes}
                           
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({EditModal: false})}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}

export default LoadHallShowTime;